module.exports = __webpack_public_path__ + "static/media/ic_calendar_next2_disabled.5be617e3.svg";